<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div>
      <div class="box">
        <div class="downloadBox">
          <div class="logo">
            <img :src="datas.logo" alt="">
          </div>
          <div class="text">
            <span>{{datas.web_title}}</span>
            <span>{{datas.desc || '为您提供全网优惠券'}}</span>
          </div>
          <div class="download" @click="jumpDownload()">
            <span>立即下载</span>
          </div>
        </div>
        <div class="particulars">
          <div class="goods_carousel" ref="swiper">
            <swiper :options="swiperOptionOne" ref="smallImages">
              <swiper-slide class="goods_swiper" v-for="(item, index) in invitation_img" :key="index">
                <img :src="item" :key="item">
              </swiper-slide>
            </swiper>
            <p class="goods_page_box" v-if="invitation_img && invitation_img.length"><span>{{index + 1}}</span>/{{invitation_img.length}}</p>
          </div>
          <div class="goodsInst" v-show="other">
            <div class="title">
              <img src="../assets/tblogo.png" alt="" v-if="Number(other.type) === 11">
              <img src="../assets/tmlogo.png" alt="" v-else-if="Number(other.type) === 12">
              <img src="../assets/jdlogo.png" alt="" v-if="Number(other.type) === 21">
              <img src="../assets/pddlogo.png" alt="" v-else-if="Number(other.type) === 31">{{other.title}}</div>
            <p class="numBox">{{other.volume}}人已购买</p>
            <div class="priceBox">
              <div class="price"><p class="new" :style="{color: '#FF5847'}"><span>￥</span>{{other.coupon_price}}</p><p class="old">￥{{other.zk_final_price}}</p></div>
              <div class="profit"  style="background: linear-gradient(-90deg,rgba(255,140,116,1),rgba(255,88,71,1))" v-if="datas.biz_id != 25">会员预估收益￥{{other.commission_money}}</div>
            </div>
            <div class="update" v-if="other.level_commission_money && (other.level_commission_money !== other.commission_money && datas.biz_id != 25)">
              <p :style="{color: '#999999'}">现在升级{{other.level_name || '运营商'}}，最高获得{{other.level_commission_money}}佣金</p><span style="background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1))" @click="jumpDownload()">立即升级</span>
            </div>
            <div class="coupon" v-if="other.coupon_money" @click="jumpDownload()">
              <img class="bg" src="../assets/coupon.png" alt="" v-if="isCouponPass === '1'">
              <img class="bg" src="../assets/couponBg.png" alt="" v-else>
              <p class="money" v-if="Number(other.coupon_money) >= 99" style="font-size: 0.8rem">{{Number(other.coupon_money)}}<span style="font-size: 0.3rem">元</span></p>
              <p class="money" v-else >{{Number(other.coupon_money)}}<span>元</span></p>
              <p class="time">使用期限 {{other.coupon_start_at}}-{{other.coupon_end_at}}</p>
            </div>
            <div class="description" v-if="other.description"><span style="background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1))">推荐</span>{{other.description}}</div>
            <!--宝贝评论-->
          </div>
          <div class="commentBox" v-if="others.rate">
            <p>宝贝评论({{others.rate.totalCount}})</p> <p class="checkAll" @click="jumpDownload()">查看全部</p>
          </div>
          <template v-if="others.rate && others.rate.rateList">
            <div class="commentContent"  v-for="(item, index) of others.rate.rateList" :key="index">
              <div class="titlee">
                <div class="head">
                  <img :src="'http:'+ item.headPic" alt="">
                </div>
                <div class="username">{{item.userName}}</div>
              </div>
              <p class="size">{{item.dateTime}}  {{item.skuInfo}}</p>
              <p class="text" style="color: #333;margin-left: 0;">{{item.content}}</p>
              <div class="imgbox" >
                <img :src="'http:'+ img" alt="" v-for="(img, i) of item.images" :key="i">
              </div>
            </div>
          </template>
          <div class="shopBoxInfo">
            <img class="shopLogo" src="../assets/pddshop.png" alt="" v-if="type !== 2 && type === 3">
            <img class="shopLogo" v-else-if="type !== 2 && others.shopIcon" v-lazy="others.shopIcon" alt="" :key="others.shopIcon">
            <img class="shopLogo" v-else-if="type !== 2 && Number(other.type) === 11" src="../assets/tbshop.png" alt="">
            <img class="shopLogo" v-else-if="type !== 2 && Number(other.type) === 12" src="../assets/tmshop.png" alt="">
            <div class="shopInfo" v-if="other.shop">
              <div class="title">
                <p>
                  <img src="../assets/super/tb1.png" alt="" v-if="type === 0"><img src="../assets/super/tm.png" alt="" v-else-if="type === 1"><img src="../assets/super/jd.png" alt="" v-else-if="type === 2"><img src="../assets/super/pdd.png" alt="" v-else-if="type === 3">{{others.shopName}}
                </p>
                <span v-if="type !== 2" @click="jumpDownload()" style="background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1));">进店逛逛</span>
              </div>
              <div class="score" v-if="type !== 2 && others.score">
                <p>宝贝描述<span  style="color: #FF5847">{{others.score[0].score}}</span></p>
                <p>卖家服务<span  style="color: #FF5847">{{others.score[0].score}}</span></p>
                <p>物流服务<span  style="color: #FF5847">{{others.score[0].score}}</span></p>
              </div>
            </div>
          </div>
          <div class="detailTitle" ref="detail" v-show="others.info_img">
            <img src="../assets/goods/detail.png" alt="">
            <!-- <img :src="info_img" alt=""> -->
          </div>
          <div class="detail" v-if="showDetail && type !== 3 && type !== 2 && others.info_img"  ref="detailBox">
            <!-- <div v-for="(item, index) of info_img" :key="index" v-html="item"></div> -->
            <img v-for="(item, index) of others.info_img" :src="item" v-lazy="item" alt :key="index" />
          </div>
          <div class="detail" v-else-if="showDetail && type === 3 && other && other.description" ref="detailBox">
            <p class="pddCon" v-html="other.description"></p>
            <img v-for="(item, index) of other.small_images" v-lazy="item" alt="" :key="index">
          </div>
          <div class="detail" v-else-if="showDetail && type === 2 && other && info_img" ref="detailBox">
            <img v-for="(item, index) of info_img" v-lazy="item" alt="" :key="index">
          </div>
        </div>
        <div class="purchase" @click="purchase" v-show="datas.biz_id != 27">
          淘口令购买
        </div>
        <div class="shade" v-show="shows">
          <div class="popUp">
            <div class="word">
              淘口令购买
              <span class="mistake" @click="shut">×</span>
            </div>
            <div class="copy">
              <span>长按选择>> </span>
              <span class="copys">拷贝</span>
            </div>
            <span class="code" id="code">{{datas.code}}</span>
            <div class="duplication" id="duplication"
                 v-clipboard:copy="datas.code"
                 v-clipboard:success="onCopy"
                 v-clipboard:error="onError">复制</div>
            <span class="sm">点击复制后，请打开【手机淘宝】购买!</span>
          </div>
        </div>
      </div>
      <!--<div class="show" v-show="win">-->
        <!--复制成功-->
      <!--</div>-->
      <a href="#" class="allow" v-show="codes">无效的code</a>
    </div>
</template>

<script>
import { Toast } from 'mint-ui'
import axios from 'axios'
import qs from 'qs'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import { VueJsonp } from 'vue-jsonp'
export default {
  name: 'commodity',
  components: {
    swiper,
    swiperSlide
    // VueJsonp
  },
  data () {
    return {
      codes: false,
      datas: {},
      invitation_img: [],
      shows: false,
      // messages: 'aaa',
      win: false,
      index: 0,
      isCouponPass: 1,
      up_operator: '运营商',
      type: 2,
      showDetail: true,
      other: '',
      item_id: '',
      score: '',
      rate: '',
      description: '',
      info_img: '',
      others:{
        'info_img':'',
        'shopName':'',
        'shopIcon':'',
        'shopUrl':'',
        'score':'',
        'rate':''
      },
      swiperOptionOne: {
        loop: true,
        on: {
          transitionEnd: () => {
            if (this.$refs.smallImages.swiper) {
              this.index = this.$refs.smallImages.swiper.realIndex
            }
          },
          sliderMove: function (event) {
            window.canRightSlipBack = false
          },
          touchEnd: function (event) {
            setTimeout(() => {
              window.canRightSlipBack = true
            }, 600)
          }
        }
      }
    }
  },
  methods: {
    shut () {
      this.shows = false
    },
    purchase () {
      this.shows = true
    },
    onCopy (e) {
      Toast({
        message: '复制成功',
        className: 'coln'
      })
      let that = this
      this.cut = false
      this.shows = true
      // this.win = true
      window.setTimeout(refreshCount, 1000)
      function refreshCount () {
        // that.shows = false
        // that.win = false
        console.log(that.shows)
      }
    },
    onError (e) {
      console.error(e)
    },
    jumpDownload () {
      this.$router.push({
        path: '/download',
        query: {code: this.code}
      })
    },
    getDetail () {
      let that = this
      axios.post(this.GLOBAL.apiUrl + '/api/' + this.datas.biz_id + '/amoy/taobao/goods-detail-url', {item_id: this.item_id}).then((res) => {
        // axios.post('https://1-1252950802.cos-website.ap-chengdu.myqcloud.com' + '/api/' + '1' + '/amoy/taobao/goods-detail', {item_id: '545242700568'}).then((resdetail) => {
        if (res.data.code === 0) {
          // 获取商品详情图片的链接
          let goodsUrl = res.data.data.goodsUrl
          // 获取商品详情商铺信息的链接
          let shopInfoUrl = res.data.data.shopInfoUrl

          that.$jsonp(goodsUrl).then((res) => {
            console.log(res.data)
            let info_img = []
            if (res.data) {
              for (var i = 0; i < res.data.wdescContent.pages.length; i++) {
                if (res.data.wdescContent.pages[i].indexOf('img') != -1 && res.data.wdescContent.pages[i].indexOf('gif') == -1) {
                  info_img.push('http:' + res.data.wdescContent.pages[i].match(/>(\S*)</)[1].match(/(\/\/)(\S*)/)[0])
                  this.others.info_img = info_img
                }
              }
            }
          })
          // 获取店铺信息
          that.$jsonp(shopInfoUrl).then(res => {
            let seller = {}
            if (res.data) {
              seller = res.data.seller
              // 存店铺名称
              this.others.shopName = seller.shopName
              // 存店铺logo
              this.others.shopIcon = 'http:' + seller.shopIcon.match(/(\/\/)(\S*)/)[0]
              // 存店铺链接
              this.others.shopUrl = 'http:' + seller.taoShopUrl.match(/(\/\/)(\S*)/)[0]
              // 存店铺评分
              this.others.score = seller.evaluates
              // 存店铺评论
              this.others.rate = res.data.rate
            }
          })
        }
      })
    }
  },
  mounted () {
    let code = this.GLOBAL.getQueryString('code')
    // let code = 'MzdfNTI4MV82MDEzODEyMTUxODk%3D#/'
    if (!code) {
      this.codes = true
    }
    axios.get(this.GLOBAL.apiUrl + '/api/w1/share/goods?code=' + code).then((res) => {
      if (res.data.code === 0) {
        this.datas = res.data.data
        this.invitation_img = res.data.data.img
        document.title = res.data.data.title
        axios.defaults.headers = {
          'Content-type': 'application/x-www-form-urlencoded'
        }
        axios.defaults.transformRequest = (data) => {
          data = qs.stringify(data)
          return data
        }
        axios.post(this.GLOBAL.apiUrl + '/api/' + this.datas.biz_id + '/amoy/taobao/search', {
          page: 1,
          keyword: this.datas.code,
          sort: '',
          isCoupon: 0}).then((ressearch) => {
          if (ressearch.data.code === 0) {
            this.other = ressearch.data.data[0]
            this.item_id = this.other.origin_id
            let t = this.other.type
            if (t === 11) {
              this.type = 0
            } else if (t === 12) {
              this.type = 1
            } else if (t === 21) {
              this.type = 2
            } else if (t === 31) {
              this.type = 3
            }
            this.getDetail()
          }
          console.log(this.other)
        })
      } else {
        this.$router.push({
          path: '/download1',
          query: {code: this.code}
        })
      }

    })
  }
}
</script>
<style lang="less">
  .swiper-pagination-clickable .swiper-pagination-bullet{
    transform: scale(1);
  }
  .swiper-pagination{
    bottom: 0.2rem;
  }
  .swiper-pagination{
    left: 50%;
    transform: translateX(-50%);
    width: 200px
  }
  .swiper-pagination li{
    margin: 0 5px;
  }
  .swiper-pagination-bullet{
    opacity: 1;
    background-color: rgba(0,0,0,0.4);
  }
  .swiper-pagination-bullet-active{
    background-color: #007aff;
  }
  .swiper-pagination{
    width: 200px;
  }
  .mint-toast is-placemiddle{
    width: 4rem;
  }
  .coln{
    width: 2.8rem;
    height: 1.1rem;
    line-height: 1.1rem;
    /*padding: 0.3rem 0!important;*/
    margin-top: -0.2rem;
    background-color: rgba(0,0,0,0.6);
    color: #fff;
    /*background-color: #000;*/
    font-size: 0.32rem;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0!important;
  }
  .detail{
    overflow: hidden;
    text-align: center;
    background: #fff;
    width: 100%;
    .pddCon{
      font-size: .24rem;
      color: #333;
      text-align: left;
      padding: .2rem;
      line-height: .46rem;
    }
    img {
      width: 100%;
      // max-width: 100% !important;
      height: auto;
    }
    .desc_anchor{
      display: none;
    }
    .ssd-module-wrap{
      width: 100%;
      .ssd-module{
        width: 100%;
        padding-top: 100%;
        height: 0;
      }
    }
  }
</style>

<style lang="less" scoped>
  .show{
    color: #fff;
    position: fixed;
    top: 273px;
    width: 120px;
    height: 40px;
    font-size: 13px;
    text-align: center;
    line-height: 40px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    background-color: black;
    opacity: 0.7;
    /*display: none;*/
    z-index: 999;
  }
  .goods_carousel{
    position: relative;
  }
  .goods_carousel .goods_page_box{
    z-index: 3;
    padding: 0 .2rem;
    color: #fff;
    border-radius: .2rem;
    justify-content: center;
    letter-spacing: 3px;
    display: flex;
    align-items: center;
    position: absolute;
    right: .30rem;
    bottom: .5rem;
    height: .4rem;
    font-size: .2rem;
    background: rgba(0,0,0,0.4);
  }
  .goodsInst{
    background: #fff;
    padding: 0.2rem;
    .title{
      font-size: .32rem;
      line-height: .48rem;
      //font-weight: bold;
      overflow: hidden;
      display: -webkit-inline-box;
      text-overflow:ellipsis;
      -webkit-line-clamp: 2;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      img{
        width: .33rem;
        height: .33rem;
        vertical-align: top;
        margin-right: .09rem;
        margin-top: .06rem;
      }
    }
    .numBox{
      margin-top: 0.1rem;
      font-size: 0.22rem;
      color: #999;
    }
    .priceBox{
      display: flex;
      justify-content: space-between;
      .price{
        display: flex;
        align-items: center;
        .new{
          font-size: .36rem;
          margin-right: 0.16rem;
          span{
            font-size: 0.24rem;
          }
        }
        .old{
          font-size: 0.26rem;
          color: #999999;
          text-decoration: line-through;
        }
      }
      .profit{
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 0.26rem;
        padding: 0 0.1rem;
        height: 0.44rem;
        border-radius: 0.06rem;
      }
    }
    .update{
      margin-top: 0.3rem;
      height: 0.62rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 0.1rem;
      background: rgba(255, 199, 0, 0.15);
      border-radius: 0.06rem;
      p{
        font-size: 0.24rem;
      }
      span{
        padding: 0 0.1rem;
        height: 0.4rem;
        line-height: 0.4rem;
        border-radius: 0.2rem;
        color: #fff;
        font-size: 0.2rem;
      }
    }
    .coupon{
      margin: 0.2rem 0.4rem;
      position: relative;
      height: 1.6rem;
      .bg{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .money{
        position: absolute;
        left: 0.4rem;
        top: 0;
        font-size: 1rem;
        color: #fff;
        line-height: 1.2rem;
        span{
          font-size: 0.3rem;
        }
      }
      .time{
        position: absolute;
        left: 0.4rem;
        bottom: 0.15rem;
        color: #fff;
        font-size: 0.2rem;
      }
    }
    .description{
      background: #F7F7F7;
      border-radius: 0.06rem;
      font-size: 0.24rem;
      margin-top: 0.2rem;
      padding: 0.1rem;
      color: #666666;
      span{
        display: inline-block;
        line-height: 0.34rem;
        color: #fff;
        padding: 0 0.1rem;
        height: 0.34rem;
        border-radius: 0.17rem;
        font-size: 0.16rem;
        margin-right: 0.1rem;
      }
    }
  }
  .commentBox {
    position: relative;
    margin-top: 0.2rem;
    font-size: .3rem;
    background: #fff;
    height: 0.8rem;
    padding: 0 0.4rem 0 0.2rem;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
    justify-content: space-between;
    p{
      line-height: 0.6rem;
      margin-top: 0.08rem;
    }
    .checkAll {
      color: #FF5847;
      margin-top: 0;
    }
  }
  .commentBox:after{
    content: " ";
    display: inline-block;
    height: 6px;
    width: 6px;
    border-width: 2px 2px 0 0;
    border-color: #FF5847;
    border-style: solid;
    -webkit-transform: matrix(.71,.71,-.71,.71,0,0);
    transform: matrix(.71,.71,-.71,.71,0,0);
    position: absolute;
    top: 50%;
    margin-top: -4px;
    right: .2rem;
  }
  .commentContent {
    font-size: .3rem;
    background-color: #fff;
    padding:.2rem;
    .titlee {
      line-height: .8rem;
      overflow: hidden;
      .head {
        float: left;
        height: .8rem;
        width: .8rem;
        border-radius: 50%;
        margin-right: .1rem;
        img {
          width: 100%;
          border-radius: 50%;
        }
      }
      .username {
        float: left;
      }
    }
    .size {
      font-size: .24rem;
      color: #999;
      margin: .15rem 0;
    }
    .imgbox {
      overflow: hidden;
      width: 100%;
      img {
        float: left;
        width: 2.28rem;
        height: 2.28rem;
        margin-right: 0.06rem;
        margin-top: 0.06rem;
      }
      img:nth-of-type(3n){
        margin-right: 0;
      }
    }
  }
  .shopBoxInfo{
    margin: 0.2rem 0;
    padding: 0.3rem 0.2rem;
    background: #fff;
    display: flex;
    .shopLogo{
      width: 1.16rem;
      height: 1.16rem;
      border-radius: 0.1rem;
      flex-shrink: 0;
      margin-right: 0.16rem;
    }
    .shopInfo{
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        p{
          font-size: 0.32rem;
          color: #666;
          display: flex;
          align-items: center;
          img{
            width: 0.3rem;
            height: 0.3rem;
            margin-right: 0.06rem;
            border-radius: 0.04rem;
          }
        }
        span{
          height: 0.44rem;
          line-height: 0.44rem;
          color: #fff;
          border-radius: 0.22rem;
          font-size: 0.2rem;
          padding: 0 0.1rem;
        }
      }
      .score{
        display: flex;
        align-items: center;
        p{
          font-size: 0.22rem;
          color: #999999;
        }
        p:nth-of-type(2){
          flex: 1;
          text-align: center;
        }
      }
    }
  }
  .detailTitle{
    height: 1.32rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    img{
      width: 4.1rem;
    }
  }
  .swiperBox {
    /*width: 100%;*/
    position: relative;
    height: 7.2rem;
    overflow: hidden;
  }
  .swiperBox .swiper {
    /*margin-top: 0.5rem;*/
  }
  .swiperBox .bgc {
    width: 100%;
    height: 2rem;
    position: absolute;
    top: -0.5rem;
    left: 0;
  }
  .swiperBox .bgc img {
    width: 100%;
    height: 100%;
  }
  .swiperBox .items {
    position: absolute;
    width: 0.80rem;
    height: 1.7rem;
    top: 1.14rem;
    right: 0.16rem;
  }
  .swiperBox .items .piece {
    width: 0.8rem;
    height: 0.8rem;
    color: red;
    font-size: 0.26rem;
    text-align: center;
    background-color: #fff;
    opacity: 0.7;
    border-radius: 4px;
  }
  .swiperBox .items .piece span {
    display: block;
  }
  .swiperBox .items .img {
    width: 0.8rem;
    height: 0.8rem;
    top: 0.1rem;
    position: relative;
  }
  .swiperBox .items .img img {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .banner {
    height: 7.2rem;
    width: 100%;
    background-color: #f7f7f7;
  }
  .banner img {
    width: 100%;
    /*height: 100%;*/
  }
  body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,textarea,p,blockquote,th,td,hr,button,article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section {
    margin:0;
    padding:0
  }
  .box{
    position: relative;
    // padding-bottom: 1.1rem;
    background: #F7F7F7;
  }
  .downloadBox{
    width: 100%;
    padding: 0.1rem 0.15rem;
    background-color: #4c4c4c;
    height: 1.0rem;
    box-sizing: border-box;
    overflow: hidden;
  }
  .logo{
    float: left;
    width: 0.80rem;
    height: 0.80rem;
    position: relative;
  }
  .logo img{
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .text{
    float: left;
    margin-left: 0.3rem;
    color: #fff;
    width: 50%;
  }
  .text span{
    display: block;
  }
  .text span:nth-child(1){
    font-size: 0.3rem;
    line-height: 0.5rem;
  }
  .text span:nth-child(2){
    font-size: 0.22rem;
    line-height: 0.3rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .download{
    float: right;
    padding: 0.1rem 0;
  }
  .download span{
    display: block;
    width: 1.80rem;
    height: 0.6rem;
    line-height: 0.6rem;
    border-radius: 0.1rem;
    text-align: center;
    font-size: 0.3rem;
    color: #fff;
    background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1));
  }

  .explain .texts{
    display: block;
    padding: 0 0.3rem;
    padding-top: 0.28rem;
    font-size: 0.3rem;
    color: black;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .message{
    overflow: hidden;
    margin-top: 0.3rem;
    padding: 0 0.2rem;
  }
  .message div{
    float: left;
  }
  .message div:nth-child(1){
    font-size: 0.3rem;
    color: #fc3357;
    font-weight: 800;
  }
  .pan1{
    font-size: 0.28rem;
    font-weight: bold;
  }
  .jiage{
    font-size: 0.45rem;
  }
  .quan{
    margin-left: 0.4rem;
    height: 0.4rem;
    border: 1px solid #fc3357;
    margin-top: 0.1rem;
  }
  .quan span:nth-child(1){
    font-size: 0.3rem;
    float: left;
    border-right: 1px solid #fc3357;
    padding: 0 0.04rem;
    color: #fff;
    background: linear-gradient(to right, #ff485f , #ffa880)
  }
  .quan span:nth-child(2){
    float: right;
    font-size: 0.24rem;
    padding: 0rem 0.16rem;
    line-height: 0.4rem;
    color: #fc3357;
  }
  .message .sell{
    line-height: 0.6rem;
    float: right;
    font-size: 0.22rem;
    color: #c2c2c2;
  }
  .purchase{
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    line-height: 1.0rem;
    display: block;
    font-size: 0.3rem;
    color: #fff;
    text-align: center;
    text-decoration:none;
    background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1));;
  }
  .popUp{
    border-radius: 9px;
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    top: 3.74rem;
    width: 6rem;
    height: 5.88rem;
  }
  .shade{
    /* width: 100%;
    height: 100%; */
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.8);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
  }
  .popUp{
    background-color: #fff;
  }
  .word{
    border-top-left-radius:8px;
    border-top-right-radius:8px;
    height: 1rem;
    width: 100%;
    font-size: 0.3rem;
    text-align: center;
    line-height: 1rem;
    background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1));;
    color: #fff;
  }
  .mistake{
    position: absolute;
    top: -2.2px;
    right: 0px;
    font-size: 0.6rem;
    width: 46px;
    /*height: 12px;*/
  }
  .copy{
    position: absolute;
    font-size: 0.22rem;
    color: #666;
    width: 3.30rem;
    height: 0.5rem;
    background-color: #ffe8e6;
    border-radius: 4px;
    margin: 0.4rem  auto;
    text-align: center;
    line-height: 0.5rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
    top: 0.8rem;
  }
  .copy span:nth-child(2){
    color: rgba(255,88,71,1);
  }
  .code{
    position: relative;
    margin: 0.4rem;
    height: 1.2rem;
    line-height: 1.5rem;
    border: 1px dashed #fc3357;
    text-align: center;
    font-size: 0.32rem;
    color: black;
    font-weight: 800;
    display: block;
    margin-top: 0.4rem;
  }
  .duplication{
    height: 0.76rem;
    width: 3rem;
    margin: 0.5rem auto;
    font-size: 0.32rem;
    color: #fff;
    background: linear-gradient(270deg,rgba(255,142,118,1),rgba(255,88,71,1));;
    border-radius: 21px;
    text-align: center;
    line-height: 0.76rem;
  }
  .sm{
    font-size: 0.22rem;
    color: #7d5a5a;
    display: block;
    margin: 0 0.8rem;
    text-align: center;
  }
  .show{
    color: #fff;
    position: fixed;
    top: 273px;
    width: 120px;
    height: 40px;
    font-size: 13px;
    text-align: center;
    line-height: 40px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 10px;
    background-color: black;
    opacity: 0.7;
    /*display: none;*/
    z-index: 999;
  }
  .swiper-container {
    /*height: 420px;*/
  }
  .swiper-slide img{
    width: 100%;
    height: 100%;
  }
  a{
    text-decoration:none;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/newGoods.vue